import { render, staticRenderFns } from "./ItemGroupDetails.vue?vue&type=template&id=62b47dd2&"
import script from "./ItemGroupDetails.vue?vue&type=script&lang=ts&"
export * from "./ItemGroupDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports